export default __webpack_public_path__ + "static/media/icons8-workers.1669ad60.svg";